<template>
  <v-layout>
    <v-container grid-list-md>
      <v-progress-linear
        :indeterminate="true"
        height="3"
        v-if="floading"
      ></v-progress-linear>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Dashboard</h3>
          <v-spacer></v-spacer>
          <!-- <v-select
            label="Academic Year"
            item-text="name"
            item-value="id"
            v-model="selected_acyear"
            :items="acyears"
            style="width:10%"
          /> -->
        </v-card-title>

        <v-card-text>
          <v-layout row wrap v-if="showStats">
            <v-flex xs12 sm4>
              <v-card>
                <v-card-title
                  primary-title
                  style="background: darkgreen; color: white"
                >
                  <div>
                    <h4 class="headline mb-0">Income</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background: darkgreen; color: white">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">money</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{ total_income | toCurrency }}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa; color: #333">
                  <p>Total Income</p>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-card-title
                  primary-title
                  style="background: darkred; color: white"
                >
                  <div>
                    <h4 class="headline mb-0">Expenses</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background: darkred; color: white">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">money</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{ total_expense | toCurrency }}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions style="background: #fafafa; color: #333">
                  <p>Total Expense</p>
                </v-card-actions>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card>
                <v-card-title
                  primary-title
                  style="background: darkslategray; color: white"
                >
                  <div>
                    <h4 class="headline mb-0">Est. Profits</h4>
                  </div>
                </v-card-title>
                <!--<v-divider></v-divider>-->
                <v-card-text style="background: darkslategray; color: white">
                  <v-layout row wrap class="stat-data">
                    <v-flex xs4>
                      <v-icon style="color: white">border_all</v-icon>
                    </v-flex>

                    <v-flex xs8>
                      <h2>{{ (total_income - total_expense) | toCurrency }}</h2>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-actions style="background: #fafafa; color: #333">
                  <p>Estimated Profits</p>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-calendar
                ref="calendar"
                color="primary"
                type="month"
              ></v-calendar>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      selected_acyear: "",
      showStats: false,
    };
  },
  created() {
    this.$store.dispatch("academicYear/getAll");
    this.$store.dispatch("incomes/getAll", { type: 1 });
    this.$store.dispatch("expenses/getAll", { type: 0 });
    this.$store.dispatch("feepayments/getAll");
    let user_roles = this.user.roles;
    //console.log(user_roles)
    if (user_roles && user_roles[0].name=="administrator") {
      this.showStats = true;
    }
  },
  computed: {
    ...mapGetters({
      acyears: "academicYear/ACYEARS",
      errors: "academicYear/ACYEAR_ERROR",
      loading: "academicYear/ACYEAR_LOADING",

      incomes: "incomes/INCOMES",
      expenses: "expenses/EXPENSES",

      feepayments: "feepayments/FEEPAYMENTS",
      ferrors: "feepayments/FEEPAYMENT_ERROR",
      floading: "feepayments/FEEPAYMENT_LOADING",

      user: "authUser",
    }),

    total_income() {
      var fromJournal = this.incomes.reduce((a, b) => {
        return a + parseFloat(b["amount"]);
      }, 0);

      var fromFeesPayments = this.feepayments
        ? this.feepayments.reduce((a, b) => {
            return a + parseFloat(b.tot_paid);
          }, 0)
        : 0;

      //console.log(fromFeesPayments)
      return (
        parseFloat(fromJournal ? fromJournal : 0) +
        (fromFeesPayments ? fromFeesPayments : 0)
      );
    },
    total_expense() {
      return this.expenses.reduce((a, b) => {
        return a + parseFloat(b["amount"]);
      }, 0);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/accountant/dashboard.vue